import type { FormField, ValidationRules } from "./types";

/** Formata um valor numérico em centavos para a máscara de moeda pt-BR. */
export function formatCurrencyInput(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return "";
  const num = parseInt(digits, 10) / 100;
  return num.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Converte as regras de data (min/max absolutos e relativos) em atributos min/max do input. */
export function dateRangeForField(field: FormField): { min?: string; max?: string } {
  const rules = (field.validation_rules as ValidationRules | null) ?? null;
  if (!rules) return {};
  const today = new Date();
  const addUnits = (amount: number, unit: string): string => {
    const d = new Date(today);
    if (unit === "days") d.setDate(d.getDate() + amount);
    else if (unit === "months") d.setMonth(d.getMonth() + amount);
    else if (unit === "years") d.setFullYear(d.getFullYear() + amount);
    return d.toISOString().slice(0, 10);
  };
  const result: { min?: string; max?: string } = {};
  if (rules.min_from_today) result.min = addUnits(rules.min_from_today.amount, rules.min_from_today.unit);
  if (rules.max_from_today) result.max = addUnits(rules.max_from_today.amount, rules.max_from_today.unit);
  if (rules.min_date) result.min = rules.min_date === "today" ? today.toISOString().slice(0, 10) : rules.min_date;
  if (rules.max_date) result.max = rules.max_date === "today" ? today.toISOString().slice(0, 10) : rules.max_date;
  return result;
}